export const LIST_ORDER = 'LIST_ORDER';
export const SHOW_ORDER_DETAIL = 'SHOW_ORDER_DETAIL';
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';